import {
    createSlice,
    PayloadAction,
    ActionReducerMapBuilder,
} from '@reduxjs/toolkit';
import { RootState } from '../../../config/store';
import { PaginatedType, TableParams } from '../../../types';
import { ILogsState, ITransaction } from './types';
import { getTransactions } from '../../../api/thunks/logs';

const initialState: ILogsState = {
    transactions: [],
    totalTransactions: 0,
    tableParams: {
        pagination: {
            current: 1,
            pageSize: 20,
        },
        filters: {},
    },
    loading: 'idle',
    error: null,
};

const logsSlice = createSlice({
    name: '@@logs',
    initialState,
    reducers: {
        clearLogsState: () => {
            return initialState;
        },
        setTableParams: (
            state: ILogsState,
            { payload }: PayloadAction<TableParams>
        ) => {
            state.tableParams = payload;
        },
        resetFilter: (state: ILogsState) => {
            state.tableParams = {
                pagination: {
                    current: 1,
                    pageSize: 20,
                },
                filters: {},
            };
        },
    },

    extraReducers: (builder: ActionReducerMapBuilder<ILogsState>) => {
        builder
            .addCase(
                getTransactions.fulfilled,
                (
                    state: ILogsState,
                    { payload }: PayloadAction<PaginatedType<ITransaction>>
                ) => {
                    state.transactions = payload.rows;
                    state.totalTransactions = payload.count;
                }
            )

            .addMatcher(
                action => action.type.endsWith('/pending'),
                state => {
                    state.loading = 'loading';
                    state.error = null;
                }
            )
            .addMatcher(
                action => action.type.endsWith('/rejected'),
                (state, action: PayloadAction<string>) => {
                    state.loading = 'idle';
                }
            )
            .addMatcher(
                action => action.type.endsWith('/fulfilled'),
                state => {
                    state.loading = 'idle';
                }
            );
    },
});

export const { clearLogsState, setTableParams, resetFilter } =
    logsSlice.actions;
export const logsReducer = logsSlice.reducer;

export const logsSelect = (state: RootState) => state.logs;
